import {Component, Input, OnInit, inject} from '@angular/core';
import {AuthenticationService} from '../../_services/authentication.service';
import {CardComponent} from '../../sidenav/card/card.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-services-side-cards',
    templateUrl: './services-side-cards.component.html',
    styleUrls: ['./services-side-cards.component.scss'],
    imports: [CardComponent, TranslateModule]
})
export class ServicesSideCardsComponent implements OnInit {

  @Input() companyName: string;

  adminNames?: string[];

  private readonly authService = inject(AuthenticationService);

  ngOnInit() {
    this.authService.myAdminNames$.subscribe(adminNames => this.adminNames = adminNames);
  }

}
